import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import FileUpload from './FileUpload';
import PreEntriesList from './PreEntriesList';
import TemplatesList from './TemplatesList';
import './Dashboard.css';

type ActiveTab = 'transactions' | 'templates';

const Dashboard: React.FC = () => {
  const { user, signOut } = useAuth();
  const [activeTab, setActiveTab] = useState<ActiveTab>('transactions');

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>Transaction Parser</h1>
        <div className="user-info">
          <span>Welcome, {user?.username}</span>
          <button onClick={handleSignOut} className="sign-out-button">
            Sign Out
          </button>
        </div>
      </header>

      {/* Tab Navigation */}
      <nav className="dashboard-tabs">
        <button
          className={`tab-button ${activeTab === 'transactions' ? 'active' : ''}`}
          onClick={() => setActiveTab('transactions')}
        >
          Transactions
        </button>
        <button
          className={`tab-button ${activeTab === 'templates' ? 'active' : ''}`}
          onClick={() => setActiveTab('templates')}
        >
          Templates
        </button>
      </nav>

      <main className="dashboard-main">
        {activeTab === 'transactions' && (
          <>
            <div className="dashboard-section">
              <h2>Upload Transactions</h2>
              <FileUpload />
            </div>

            <div className="dashboard-section">
              <h2>Pre-entries</h2>
              <PreEntriesList />
            </div>
          </>
        )}

        {activeTab === 'templates' && (
          <div className="dashboard-section">
            <TemplatesList />
          </div>
        )}
      </main>
    </div>
  );
};

export default Dashboard;